<template>
  <div class="customer-avartar" v-if="user.contact_fullname">
    <div class="title-avartar">
      <p>{{ $t("welcome") }}</p>
      <h3>{{ user.contact_fullname }}</h3>
      <h3>{{ user.email }}</h3>
    </div>
  </div>
</template>
<script>
export default {
  name: "customerNav",
  props: {
    user: {
      Type: Object,
    },
  },
};
</script>